import React, { Component } from 'react';
import _, { isEmpty, get } from 'lodash';
import routes from "../../../../../../routes";
import { handleFieldError, initializeForm } from "../../../../../../utils/form-validation";
import { formFields } from "./constant";
import { connect } from 'react-redux';
import Input from "../../../../../../components/FormElements/Input";
import { ionAdsFields } from "./constant";
import ReactSelect2 from "../../../../../../components/ReactSelect";
import MySelect from '../../../../../../components/CheckboxSelect';
import { withRouter } from 'react-router-dom';
import { postIonCampaignAction, deleteAccountsAction, postSyncCampaignIonAction } from "../../../../../../actions";
import ToastModal from "../../../../../../components/ToastModal";



class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      ionAds: [{ ionList: [], optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignDetailsList: {}, campaignSelected: [], sync: false, ionMasterAccountID: "", ionAccountID: "", ionCurrency: "", accountSelected: {}, errors: {}, touched: {} }],
      handleApplyClicked: false,
      disableLogin: true ,
    };
  }

  componentWillMount() {
    const { tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList,editId } = this.props;
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);

    this.setState({ form, errors });
    if (editId) {
      this.editId();
    }
  }


  editId = () => {
    const { ionEditData = [], editId, handleCallback } = this.props;
    const { ionAds } = this.state;

    if (editId) {
      let ionAdsData = ionEditData.map((item) => {
        return {
          isInfomo : item.isInfomo,
          ionMasterAccountID: item.masterAccountId,
          ionAccountID: item.accountId,
          ionCurrency: item.currency,
          optionSelected: [],
          status: false,
          accountsList: [],
          accountsToSet: false,
          accToggle: false,
          campaignToggle: false,
          fetchAccount: [],
          accountDisabled: false,
          campaignDetailsList: {},
          campaignSelected: [],
          sync: true,
          accountEmail: "",
          accountSelected: {},
          errors: { ionToken: {} },
          touched: { ionToken: false },
        };
      });

      this.setState({ ionAds: ionAdsData },()=>{
        handleCallback(ionAdsData, "login");
      });
    } else {
      this.setState({ ionAds });
    }
  };


  handleAddClick = () => {
    const { ionAds } = this.state;
    const { handleCallback } = this.props;
    this.setState({ ionAds: [...this.state.ionAds, { ionList: [], optionSelected: [], status: false, masterAccounts: [], masterDisabled: false, accToggle: false, campaignToggle: false, fetchAccount: [], accountDisabled: false, campaignDetailsList: {}, campaignSelected: [], sync: false, ionMasterAccountID: "", ionAccountID: "", ionCurrency: "", accountSelected: {}, errors: {}, touched: {} }] }, () => {
      handleCallback(ionAds, "login");
    });
  };

  handleChange = (e, index) => {
    let { form } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });
   

    // if (name === "ionAccountID" || name === "ionCurrency") {
    const list = [...this.state.ionAds];
    list[index][name] = value;
    this.setState({ ionAds: list });
    // }

    if (name === "ionMasterAccountID") {
      const disableLogin = value === "";
      this.setState({ disableLogin });
    }
    


  };


  handleTouch = (e, index) => {
    const { name,value } = e.target;

    // if (name.includes("ion")) {
    let { ionAds } = this.state;
    // console.log("ion", ionAds);
    let clonedionAdsData = _.cloneDeep(ionAds[index]);
    let { error } = handleFieldError(ionAds[index][e.target.name], ionAdsFields[e.target.name]);
    ionAds[index].errors[`${e.target.name}`] = error;
    ionAds[index].touched[`${e.target.name}`] = true;
    this.setState({ ionAds });
    // }
  };


  handleLogin = async (ionList, index) => {
    const { ionAds } = this.state;
    const { postIonCampaignAction, advId = -1, tenantId, authToken, userId ,advertiserId} = this.props;
    let editId = JSON.parse(localStorage.getItem("editId"));
    let clonedionAdsData = _.cloneDeep(ionAds[index]);
    let { error, isValid } = handleFieldError(
      clonedionAdsData.ionMasterAccountID      ,
      ionAdsFields.ionMasterAccountID
    );

    if (!isValid) {
      ionAds[index]["errors"]["ionMasterAccountID"] = error;
      ionAds[index]["touched"]["ionMasterAccountID"] = true;
      this.setState({ ionAds });
    } 
    else {

    let ionLoginData = {
      tenantToken: ionList.ionMasterAccountID,
      advId: editId,
      isSync : 0,
      isInfomo : 0
    }
   
      
      if (ionLoginData) {
        const { responseCode: { status = "",msg }, response } = await postIonCampaignAction({ tenantId, authToken, userId, payload:ionLoginData });

        if (status == "Success") {
          this.setState({ res: response });

          let res = response.campList.map(camp => {
            return {
              label: camp.campName,
              value: camp.campName,
              name: camp.campName,
              contentType: camp.contentType,
              isExist: camp.isExist,
              campId: camp.campId,
              status: camp.status,
              sDate: camp.sDate,
              eDate: camp.eDate,
              category: camp.category,
              subcategory:camp.subcategory
            }
          })
          // console.log("res123",res)

          let obj = {
            tenantName: response.tenantName,
            tenantId: response.tenantId,
            advId: response.advId,
            username: response.username,
            password: response.password,
            campList: res
          }

          // console.log("obj123",obj)

          ionAds[index].campaignToggle = true;
          ionAds[index].camplist = res;
          ionAds[index].campaigns = obj;
          ionAds[index].campaignSelected = res.filter((dataFilter) => dataFilter.isExist == 1);
          this.setState({ campList: obj, ionAds })
        }
        else{
        this.toast(status, msg, true,true);
        }
      } 
      else {
        this.setState({ enableToast: true, confirmationMsg: "Please Select A Account.", toastMsg: "", toastStatus: "required" });
      }
    }
  }


  handleResync = async (ionList, index) => {
    const { ionAds } = this.state;
    const { postIonCampaignAction, advId = -1, tenantId, authToken, userId ,advertiserId} = this.props;
    let editId = JSON.parse(localStorage.getItem("editId"));
    
    let ionLoginData = {
      tenantToken: ionList.ionMasterAccountID,
      advId: editId,
      isSync : 1,
      isInfomo:0

    }
      
      if (ionLoginData) {
      const { responseCode: { status = "",msg }, response } = await postIonCampaignAction({ tenantId, authToken, userId, payload:ionLoginData });

      if (status == "Success") {
        this.setState({ res: response });

        let res = response.campList.map(camp => {
          return {
            label: camp.campName,
            value: camp.campName,
            name: camp.campName,
            contentType: camp.contentType,
            isExist: camp.isExist,
            campId: camp.campId,
            status: camp.status,
            sDate: camp.sDate,
            eDate: camp.eDate,
            category:camp.category,
            subcategory:camp.subcategory
          }
        })
        // console.log("res123",res)

        let obj = {
          tenantName: response.tenantName,
          tenantId: response.tenantId,
          advId: response.advId,
          username: response.username,
          password: response.password,
          campList: res
        }

        ionAds[index].campaignToggle = true;
        ionAds[index].camplist = res;
        ionAds[index].campaigns = obj;
        ionAds[index].campaignSelected = res.filter((dataFilter) => dataFilter.isExist == 1);
        this.setState({ campList: obj, ionAds })
      }
      else{
      this.toast(status, msg, true,true);
      }
    } 
    else {
      this.setState({ enableToast: true, confirmationMsg: "Please Select A Account.", toastMsg: "", toastStatus: "required" });
    }
  }




  handleSelectChange = (selected, index, name, campList) => {

    if (name === "master-account") {
      let accountId = [];
      selected.isMasterNew = 0;

      let obj = {
        masterId: selected.masterid,
        isMasterNew: selected.isMasterNew,
        email: selected.email,
        refreshToken: selected.refreshToken
      }

      accountId.push(obj);

      const { ionAds } = this.state;
      ionAds[index].optionSelected = selected;
      this.setState({ ionAds, accountIds: accountId, handleApplyClicked: false });

    } else if (name === "accounts") {
      let accounts = [];
      selected.isMasterNew = 0;
      selected.isNew = 0;

      let obj = { customerId: selected.customerId, masterId: selected.masterId, currencyCode: selected.currencyCode, isNew: selected.isNew, isMasterNew: selected.isMasterNew, refreshToken: selected.refreshToken, email: selected.email }

      accounts.push(obj);

      const { ionAds } = this.state;
      ionAds[index].accountSelected = selected;
      ionAds[index].googleAdvertiserID = selected.customerId;
      ionAds[index].googleMasterAccountID = selected.masterId;
      ionAds[index].googleCurrency = selected.currencyCode

      this.setState({ ionAds, accountSelected: accounts, handleApplyClicked: false });

    } else if (name === "campaigns") {
      console.log("selected123", selected)
      const { ionAds } = this.state;
      ionAds[index].campaignSelected = selected;
      this.setState({ ionAds });

      let changeSelectedData = selected.map(sel => {
        return {
          campName: sel.campName,
          contentType: sel.contentType,
          isExist: (sel.isExist == 0) ? 1 : sel.isExist,
          campId: sel.campaignId,
          status: sel.status,
          sDate: sel.sDate,
          eDate: sel.eDate

        }
      })

      this.setState({ campaignPayload: changeSelectedData, handleApplyClicked: false })
    }
  };

    // ========== sync campaign =======
  handleSyncCampaign = async (index) => {
      const { campList, campaignPayload, res, ionAds } = this.state;
      console.log("campList", campList);  
      const { postSyncCampaignIonAction, tenantId, handleCallback, syncId, toast, advId = -1, authToken, userId } = this.props;
  
  
      let clonedIonData = _.cloneDeep(ionAds[index]);
       
      if (clonedIonData && clonedIonData.campaignSelected && clonedIonData.campaignSelected.length > 0) {
        let allCampaignsSelected = ionAds[index] && ionAds[index].campaigns &&  ionAds[index].campaigns.campList ;
        if(allCampaignsSelected == undefined){
          allCampaignsSelected = ionAds[index] && ionAds[index].campaignDetailsList &&  ionAds[index].campaignDetailsList.campList ;
        }
        let changeSelectedData = []
  
        allCampaignsSelected.forEach((dataAllSel)=>{
  
          let findDataAlready = clonedIonData.campaignSelected.find((dataFind)=>dataFind.campId == dataAllSel.campId);  
  
          if(findDataAlready){
            let obj = {
              campName: dataAllSel.name,
              contentType: dataAllSel.contentType,
              isExist: 1,
              campId: dataAllSel.campId,
              status: dataAllSel.status,
              sDate: dataAllSel.sDate,
              eDate: dataAllSel.eDate,
              category:dataAllSel.category,
              subcategory:dataAllSel.subcategory
    
            }
            changeSelectedData.push(obj);
          }
          else if(!findDataAlready && dataAllSel.isExist == 1){
            let obj = {
              campName: dataAllSel.campName,
              contentType: dataAllSel.contentType,
              isExist: 0,
              campId: dataAllSel.campId,
              status: dataAllSel.status,
              sDate: dataAllSel.sDate,
              eDate: dataAllSel.eDate,
              category:dataAllSel.category,
              subcategory:dataAllSel.subcategory
    
            }
            changeSelectedData.push(obj);
          }
  
        })
        campList.campList = changeSelectedData;

  
  
        const { responseCode: { status = "", msg = "" } } = await postSyncCampaignIonAction({ tenantId, authToken, userId, payload:campList });
        if (status == "Success") {
          handleCallback(ionAds, "login");
          // this.setState({ enableToast: true, toastStatus: status, toastMsg: msg, redirectToList: true });
          this.toast(status, msg, true,true);
        }

        else{
          handleCallback(ionAds, "login");
          this.toast(status, msg, true,true);
        }
  
      }
      else {
        let toastStatus = "required";
        let msg = "Please select a campaign.";
        this.setState({ enableToast: true, toastStatus: toastStatus, toastMsg: msg });
        // this.setState({ enableToast: true, confirmationMsg: "Please Select A Campaign.", toastMsg: "", toastStatus: "required" });
      }
    }

      
  toast = (status, msg, redirect,isRedirectToAdvertiser=false) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg, redirectPage: redirect,isRedirectToList:isRedirectToAdvertiser });
    return;
  }
  handleToastStatus = (status, redirect) => {
    // console.log("IIIIIIII");
    const {isRedirectToList} = this.state;
    const { match: { params: id }, history } = this.props;
    this.setState({ enableToast: status, redirectPage: false, toastStatus: "", toastMsg: "" }, () => {
      if (redirect || isRedirectToList) {
        history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
      }
    });
  }

  confirmationCallbackModel = (id) => {
    // console.log('hello2');
    const { facebookAds, isReloadPage } = this.state;
    const { handleCallback } = this.props;
    this.setState({ enableToast: false }, () => {
      if (isReloadPage) {
        this.deleteRecord();
      }
    });
  }


  deleteRecord = async () => {
    const { tenantId, authToken, userId, deleteAccountsAction } = this.props;
    const { accountIdForDelete, indexForDelete } = this.state;
    const { responseCode: { status = "", msg }, responseList } = await deleteAccountsAction({ tenantId, authToken, userId, accountId: accountIdForDelete });
    if (status == "Success") {
      // console.log("Deleted- accountId", accountIdForDelete);
      const { ionAds } = this.state;
      const { handleCallback } = this.props;
      const list = [...ionAds];
      list.splice(indexForDelete, 1);
      this.setState({ ionAds: list });
      handleCallback(list, "login");
      // window.location.reload();
    }
    else if (status.toLowerCase() == 'fail') {
      let toastStatus = "error";
      let msgStr = msg && msg.length > 0 ? msg : 'Something went wrong';
      this.setState({ enableToast: true, toastStatus: toastStatus, toastMsg: msgStr });
    }
  }

    // ========== remove google adwords account ========
    handleRemoveClick = async (index, accountId) => {
      // console.log("accountId", accountId);
  
      this.setState({ isReloadPage: true, enableToast: true, accountIdForDelete: accountId, indexForDelete: index, toastStatus: "confirmation", confirmationMsg: 'Kindly confirm the deletion of this record. This action cannot be undone.' });
  
    }


    handleCloseBtn = async (index) => {
      const { ionAds } = this.state;
      const { handleCallback } = this.props;
      const list = [...ionAds];
      list.splice(index, 1);
      this.setState({ ionAds: list });
      handleCallback(list, "login");
    }

    goToList = () => {
      const { match: { params: id }, history } = this.props;
      history.push('/' + routes.mainRoute + '/' + routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser);
    }  
    
  


  

  render() {
    const { submited, errors, touched, form, advetiderListData, ionAds, handleApplyClicked, campList,disableLogin,enableToast,
      toastMsg,
      toastStatus,
      confirmationMsg } = this.state;
    const { options, path } = this.props;
    let Option = options.optionFun;
    let multiValue = options.multiValue;
    // console.log("disableLogin",disableLogin)
    // console.log("ionAds",ionAds)


    return (
      <>
              {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.admin + '/' + routes.admin.advertiser.newAdvertiser}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            // redirect={redirectPage}
            poc={true}
          />
        }
        <div className='main-class-wrap'>
          <div className={`col-md-8 offset-md-2`}>
            {
              ionAds.map((ionList, index) => (
                // !ionList.sync ?
                // ionList.status ?

              ionList.isInfomo == 1 ?

              <div class="col-md-12 mb-4 manualCard">
                <h5 class="text-dark">ION Account {index + 1} :</h5>
                <div>
                      <h5>Infomo Seat</h5>

                    </div>
                    <div className='btn-manual text-right mt-2'>
                      <button className="btn-remove" onClick={() => this.handleRemoveClick(index, ionList.ionAccountID)} style={{ top: '40px' }} ><i className='mdi mdi-delete'></i></button>
                    </div>
              </div>
                
                :
                
                <>
                  <div className='col-md-12 mb-4 manualCard' key={index}>
                    {
                      !ionList.sync &&
                      <button className="btn-delete" onClick={() => this.handleCloseBtn(index)}><i className='mdi mdi-close'></i></button> 
                    }
                    <h5 className='text-dark'>ION Account {index + 1} :</h5>
                    <div className=''>
                      <Input
                        onChange={(e) => this.handleChange(e, index)}
                        onBlur={(e) => this.handleTouch(e, index)}
                        value={ionList.ionMasterAccountID}
                        setting={ionAdsFields[ionAdsFields.ionMasterAccountID.key]}
                        disabled ={ionList.campaignToggle || ionList.sync}
                      error={ionList.errors[ionAdsFields.ionMasterAccountID.key]}
                      // submited={submited}
                      touched={ionList.touched[ionAdsFields.ionMasterAccountID.key]}
                      />
                    </div>
                    {/* <div className=''>
                      <Input
                        onChange={(e) => this.handleChange(e, index)}
                        onBlur={(e) => this.handleTouch(e, index)}
                        value={ionList.ionAccountID}
                        setting={ionAdsFields[ionAdsFields.ionAccountID.key]}
                      // error={ionList.errors[ionAdsFields.ionAccountID.key]}
                      // submited={submited}
                      // touched={ionList.touched[ionAdsFields.ionAccountID.key]}
                      />
                    </div> */}

                   { !ionList.campaignToggle  &&
                      <div className='btn-manual mt-2'>
                        {/* <button key={index}   className={`loginBtn loginBtn--ion ${disableLogin ? 'bg-secondary pe-none text-dark border border-light' : 'bg-primary'}`}  disabled={disableLogin} onClick={() => this.handleResync(ionList, index)} > */}
                       { ionList.sync ?
                       <div className='d-flex justify-content-end'>
                          <button onClick={() => this.handleResync(ionList, index)} className="btnSync ml-2 mr-2"><i className='mdi mdi-sync'></i></button>
                          <button className="btn-remove" onClick={() => this.handleRemoveClick(index, ionList.ionAccountID)} style={{ top: '40px' }} ><i className='mdi mdi-delete'></i></button>
                       </div>
                          :
                        <button key={index}   className={`loginBtn loginBtn--ion bg-primary`} onClick={() => this.handleLogin(ionList, index)} >
                          Login with ION
                        </button>}
                      </div>
                    }

                    {ionList.campaignToggle && ionList.camplist.length == 0 &&
                      <div className='d-flex justify-content-between align-items-center'>
                        <p className='m-0 pl-1 text-danger font-weight-bold'>No Campaigns available</p>
                        <button className='btn-primary btn-add ml-2 align-self-end' id='exit-screen' onClick={() => this.goToList()}>Go back</button>
                      </div>
                    }


                    {
                      ionList.campaignToggle && ionList.camplist.length > 0 ?
                        <div className='d-flex flex-column'>
                          <h6>Select Campaigns</h6>
                          <div className='platform col-md-12 p-0'>
                            <MySelect
                              options={ionList.camplist}
                              // options={camplist}
                              isMulti
                              closeMenuOnSelect={false}
                              hideSelectedOptions={false}
                              components={{ Option, multiValue }}
                              onChange={(selected) => this.handleSelectChange(selected, index, 'campaigns')}
                              allowSelectAll={true}
                              value={ionList.campaignSelected}
                              className="selectBox"
                            />
                          </div>
                          <button className='btn-add btn-primary ml-2 align-self-end mt-3' id='exit-screen' onClick={() => this.handleSyncCampaign(index)}>Save</button>
                        </div> 
                        : ""
                        
                    }
                  </div>
                </>
              ))
            }
          </div>

          <div className='addBtn' style={{ textAlign: "right" }}>
            <button className='btn-add-io' style={{ marginTop: "0px", float: "none" }} onClick={() => this.handleAddClick()}><i className="mdi mdi-plus-box"></i>
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(connect(state => ({
  configurationList: get(state, 'app.configurationData.responseList', []),
  ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
  tenantId: get(state, 'app.preSignInState.tenantId', ''),
  userId: get(state, 'app.preSignInData.userId', ''),
  authToken: get(state, 'app.signInData.authToken', ''),
  responseAdvertiser: get(state, 'app.preSignInData.responseList', []),
}), { postIonCampaignAction,
      deleteAccountsAction,
      postSyncCampaignIonAction
    })(index));